var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchWhiteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7567 19.0949L15.8125 14.9927C16.8266 13.7871 17.3823 12.2702 17.3823 10.6911C17.3823 7.0017 14.3806 4 10.6911 4C7.0017 4 4 7.0017 4 10.6911C4 14.3806 7.0017 17.3823 10.6911 17.3823C12.0762 17.3823 13.3961 16.9645 14.5246 16.1715L18.4988 20.3048C18.6649 20.4773 18.8883 20.5725 19.1278 20.5725C19.3544 20.5725 19.5694 20.4861 19.7326 20.329C20.0794 19.9953 20.0904 19.442 19.7567 19.0949ZM10.6911 5.74551C13.4182 5.74551 15.6367 7.96406 15.6367 10.6911C15.6367 13.4182 13.4182 15.6367 10.6911 15.6367C7.96406 15.6367 5.74551 13.4182 5.74551 10.6911C5.74551 7.96406 7.96406 5.74551 10.6911 5.74551Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchWhiteOutline);
export default __webpack_public_path__ + "static/media/ic_search_white_outline.07d0f47e6d74a2828186fe10bdf6bd16.svg";
export { ForwardRef as ReactComponent };